import Vue from 'vue';
import VueI18n from 'vue-i18n';
import loadLocaleMessages, {loadTenantLocaleMessages} from '@shared_utils/loadLocaleMessage';

Vue.use(VueI18n);

// 사용자가 고른 화면 언어를 새로고침/재방문에도 유지한다 (dropdown-language.vue 가 같은 키로 저장)
export const LOCALE_STORAGE_KEY = 'qesg_locale';

// ?l= 우선순위: query > localStorage > env > ko. 'ch' 는 이미 배포된 링크의 옛 중국어 코드라 'ca' 로 바꾼다.
// query 에 모르는 값이 오면 en (기존 /reg 규칙). 저장값이 모르는 값이면 무시한다.
export function resolveLocale(query_lang, available) {
    const _query = {ch: 'ca'}[query_lang] || query_lang;
    if (_query) return available.includes(_query) ? _query : 'en';
    try {
        const _saved = localStorage.getItem(LOCALE_STORAGE_KEY);
        if (_saved && available.includes(_saved)) return _saved;
    } catch (e) { /* 저장소 접근 불가 — 기본값 */ }
    return process.env.VUE_APP_I18N_LOCALE || 'ko';
}

const i18n = new VueI18n({
    locale: 'ko', // 아래에서 messages 로드 후 resolveLocale 로 확정
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ko', //'ko'
    silentTranslationWarn: true,
    messages: loadLocaleMessages()
});

i18n.locale = resolveLocale(new URLSearchParams(window.location.search).get('l'), i18n.availableLocales);
document.documentElement.lang = i18n.locale;

// 테넌트 로케일은 비동기 병합 — 로그인 대문은 tenant.js i18nOverrides(동기)가 이미 처리
loadTenantLocaleMessages(i18n);

export default i18n;
